/** @jsxImportSource @emotion/react */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {css} from '@emotion/react';
import {connect} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import * as setupActions from '@/actions/setupActions';
import * as updateSystemAction from '@/actions/updateSystemAction';
import {Get} from '@/api/request';
import TextExplorer from '@/components/explorer/explorerView/textExplorer/TextExplorer';
import {LAYOUT, primaryBackgroundColor, proteinConcentrationColor} from '@/constants/appStyle';
import * as APPDATA from '@/constants/pcConstAppData';
import {getSessionStorage} from '@/libs/appHelper';
import {consoleLog, consoleError} from '@/libs/consoleHelper';
import {eventBusObject} from '@/observers/eventBus';

import {EventUpdateSystem} from '../updateSystem/UpdateSystem';

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  releaseNotes: store.updateSystemStore.ReleaseNotes,
  isRequestData: store.updateSystemStore.SystemUpdatePending,
  isRestartLater: store.updateSystemStore.IsRestartLater,
  downloadBinaryStatus: store.updateSystemStore.StatusDonloadBinaryUpdate,
}))
class ReleaseNotes extends React.Component {
  constructor(props) {
    super(props);

    this._bus = eventBusObject();
    this._isReqReleaseNotes = false;
    this._intervalGetReleaseNotes = undefined;
  }

  componentDidMount() {
    this.initialState();
    this.GetReleaseNoteData();
    this._intervalGetReleaseNotes = setInterval(() => {
      if (this._isReqReleaseNotes) {
        this.checkIsDataAvailable();
      }
    }, 500);
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.downloadBinaryStatus !== nextProps.downloadBinaryStatus) return true;
    if (this.props.isRestartLater !== nextProps.isRestartLater) return true;
    if (this.props.releaseNotes !== nextProps.releaseNotes) return true;
    return false;
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isRestartLater !== prevProps.isRestartLater ||
      this.props.downloadBinaryStatus !== prevProps.downloadBinaryStatus
    ) {
      this.initialState();
    }
  }

  checkIsDataAvailable = () => {
    if (this.props.releaseNotes !== undefined) {
      this._isReqReleaseNotes = false;
      this.props.dispatch(loadingActions.showLoading(false));
      clearTimeout(this._intervalGetReleaseNotes);
    }
  };

  onClickTopMenu = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.UPDATE: {
        let UpdateType = [];
        UpdateType = getSessionStorage(APPDATA.SESSION_STORAGE_KEY.UPDATE_TYPE_SYSTEM);
        consoleLog('Download & Update : ', UpdateType);
        this._bus.publish(EventUpdateSystem.DownloadBinaryUpdate, {UpdateType});
        break;
      }
      default:
        break;
    }
  };

  GetReleaseNoteData = () => {
    this.props.dispatch(
      loadingActions.updateLoading({
        showLoading: true,
        loadingText: 'Loading',
        loadingClickEvent: undefined,
        loadingButton1: {
          label: APPDATA.CANCEL,
          onClick: () => {
            this.props.dispatch(loadingActions.showLoading(false));
            this.backToPrevPage();
          },
        },
      }),
    );

    this._isReqReleaseNotes = true;
    this.getReleaseNotes();
  };

  getReleaseNotes = () => {
    this.props.dispatch(updateSystemAction.setSystemUpdatePending());
    const params = {};
    const passingVariabel = {};
    Get(
      APPDATA.API.RELEASE_NOTE,
      params,
      (response) => {
        this.props.dispatch(updateSystemAction.setReleaseNotes(response.data));
        consoleLog('Success Get Release Notes', response);
      },
      passingVariabel,
      (error) => {
        consoleError('Error Get Release Notes', error.response);
      },
      (response) => {
        consoleLog('Failed Get Release Notes', response);
      },
    );
  };

  initialState = () => {
    this.props.dispatch(setupActions.updateActiveMenu(APPDATA.RELEASE_NOTES));
    const topButtonProperties = {
      id: APPDATA.UPDATE,
      label: APPDATA.UPDATE,
      onClick: this.onClickTopMenu,
      disabled:
        this.props.isRestartLater ||
        this.props.downloadBinaryStatus?.Status === APPDATA.DownloadState.DOWNLOADING ||
        this.props.downloadBinaryStatus?.Status === APPDATA.DownloadState.COMPLETE,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.backToPrevPage,
    };
    const titleMenuProperties = APPDATA.RELEASE_NOTES;
    this.setupTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties);
  };

  // eslint-disable-next-line class-methods-use-this
  backToPrevPage = () => {
    window.location.href = APPDATA.INFO_AND_SUPPORT_ADDRESS;
  };

  // eslint-disable-next-line class-methods-use-this
  getSelectedList = () => {
    consoleLog('Selected');
  };

  setupTopMenuProperties = (topButtonProperties, backButtonProperties, titleMenuProperties) => {
    this.props.dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
      }),
    );
    this.props.dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  render() {
    const {isRemoteView, fontSize, releaseNotes} = this.props;
    const style = {
      constraint: {
        fontSize,
      },
    };
    const ReleaseNotetext = releaseNotes === undefined ? undefined : releaseNotes.ReleaseNotes;

    const footerStyle = css({
      height: LAYOUT.bottomMenuHeight,
      backgroundColor: primaryBackgroundColor,
      color: proteinConcentrationColor,
      alignSelf: 'flex-end',
      width: '100%',
    });

    return (
      <div
        style={style.constraint}
        className={isRemoteView ? 'remoteViewReleaseNotes' : ''}
      >
        {/* <CheckUpdateSystem /> */}
        <TextExplorer
          listContent={ReleaseNotetext}
          callBackSelectedList={this.getSelectedList}
          navigationType="BAR"
          isFullView
        />

        <div css={footerStyle} />
      </div>
    );
  }
}
export default ReleaseNotes;
